import { render } from "./createDealerGroup.vue?vue&type=template&id=2ff36ad7"
import script from "./createDealerGroup.vue?vue&type=script&lang=js"
export * from "./createDealerGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__